import get from 'lodash.get';

/**
 * Intended for <select>'s, this component adds an 'active' class to whatever
 * element matches the `value` in the selected <option>. It also removes 'active'
 * from all of that element's direct siblings.
 *
 * NOTE: one caveat is that in order for this to work, siblings need to be
 * 'alone' inside a wrapper element. Usually wrapping them in a <span> is
 * all that's necessary, but this is not always possible.
 */

class SetActive {
  constructor(el) {
    this.el = el;

    el.addEventListener('change', evt => {
      const param = evt.target.dataset.param;
      const value = evt.target.value;
      const elWithGivenAttr = this.getElementWithGivenAttribute(evt.target, 'value', value);
      const paramValue = elWithGivenAttr.dataset.paramValue || elWithGivenAttr.text;

      if (!value) {
        return;
      }

      history.replaceState(null, '', this.getUpdatedURL(param, encodeURI(paramValue)));

      // grab the first element with that target classname
      const targets = document.getElementsByClassName(value);

      // if no target elements were found, exit
      if (!targets.length) {
        return;
      }

      // deactivate all currently active items before proceeding
      [...this.el.childNodes].map(opt => {
        if (opt.value !== undefined) {
          [...document.getElementsByClassName(opt.value)].map(targetEl => {
            if (targetEl.classList.contains('active')) {
              targetEl.classList.remove('active');
            }
          });
        }
      });

      [...targets].map(activeTarget => {
        activeTarget.classList.add('active');
      });

      // also synchronize any other SetActive components on the page with the
      // same target
      [...document.getElementsByClassName(`js-set-active`)].map(el => {
        if (el.value !== value) {
          el.value = value;
        }
      });
    });

    this.syncWithURL(el);
  }

  /**
   * Get current URL search params
   *
   * @return URLSearchParams
   */
  getURLSearchParams() {
    return new URLSearchParams(window.location.search);
  }

  /**
   * Get an updated search param with given
   * key value query
   *
   * @param string key
   * @param string value
   *
   * @return string
   */
  getUpdatedURL(key, value) {
    const current = this.getURLSearchParams();
    current.set(key, value);
    return `?${current.toString()}`;
  }

  /**
   * Get an element under parent with given attribute value pair.
   *
   * @param Node parent
   * @param string attribute
   * @param string value
   *
   * @return Node
   */
  getElementWithGivenAttribute(parent, attribute, value) {
    const children = parent.childNodes;
    return [...children].find(child => get(child, attribute) === value);
  }

  /**
   * Sync given element with the query param.
   *
   * @param object el
   */
  syncWithURL(el) {
    const params = this.getURLSearchParams();
    const paramValue = decodeURI(params.get(el.dataset.param) || '');

    const matchedEl =
      this.getElementWithGivenAttribute(el, 'dataset.paramValue', paramValue) ||
      this.getElementWithGivenAttribute(el, 'text', paramValue);

    if (!matchedEl) {
      return;
    }

    el.value = matchedEl.value;
    el.dispatchEvent(new Event('change'));
  }
}

export default SetActive;
